import { useState } from "react";
import {BsArrowLeftCircleFill, BsArrowRightCircleFill} from "react-icons/bs"

export default function ProductCarrousel(props){

    const [slide, setSlide] = useState(0);

    const [transitionClass, setTransitionClass] = useState('')
    const [isTransitioning, setIsTransitioning] = useState(false);

    const nextSlide = () => {
        handleImageChange(slide === props.imgLink.length - 1 ? 0 : slide + 1, true);
    };

    const prevSlide = () => {
        handleImageChange(slide === 0 ? props.imgLink.length - 1 : slide - 1, false);
    };

    function handleImageChange(index, isGoingRight){
        if (isTransitioning || index === slide) return; // Si una transición está en curso, salir

        setIsTransitioning(true); // Bloquear otras transiciones
        setTransitionClass(`slide-out-${isGoingRight ? 'right' : 'left'}`);
        setTimeout(() => {
            setSlide(index)
            setTransitionClass(`slide-in-${isGoingRight ? 'right' : 'left'}`);
            setTimeout(() => {
                setTransitionClass('');
                setIsTransitioning(false); // Permitir nuevas transiciones
            }, 200); // Duración de la animación de entrada
        }, 200); // Duración de la animación de salida
    }

    const baseClass = props.isLargeScreen ? "img-paneles" : "img-paneles-movil"

    return(
        <div className="product-image-carrousel">
            <BsArrowLeftCircleFill onClick={prevSlide} className="arrow arrow-left"/>
            <div className={transitionClass}>
            {
                props.imgLink.map((imageIndex, idx) => {
                    return(
                        <img src={imageIndex} 
                        alt={`char${props.index}`}
                        className={slide === idx ? baseClass : `${baseClass} img-paneles-hidden`}
                        key={`image-key-${idx}`}/>
                    )
                })
            }
            </div>
            <BsArrowRightCircleFill onClick={nextSlide} className="arrow arrow-right"/>
            <span className="indicators">
                {props.imgLink.map((_, idx) => {
                return (
                    <button
                    key={`indicator-key-${idx}`}
                    className={
                        slide === idx ? "indicator" : "indicator indicator-inactive"
                    }
                    onClick={() => handleImageChange(idx, idx > slide)}
                    ></button>
                );
                })}
            </span>
        </div>
    )
}